"use client";

import { useSession, signOut } from "next-auth/react";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "./ThemeToggle";
import { UserNav } from "./UserNav";
import { LogOut } from "lucide-react";

export function Header() {
  const { data: session } = useSession();
  const pathname = usePathname();

  if (!session) {
    return null;
  }

  const showDocsButton = pathname === "/admin/users";

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto flex h-14 items-center px-4">
        <div className="mr-4 hidden md:flex">
          <Link
            href="/create-pop/select-city"
            className="mr-6 flex items-center space-x-2"
          >
            {/* Logo vai aqui */}
            <span className="hidden font-bold sm:inline-block">
              POP Documenter
            </span>
          </Link>
        </div>
        <div className="flex flex-1 items-center justify-between space-x-2 md:justify-end">
          {showDocsButton && (
            <Link href="/create-pop/select-city">
              <Button variant="outline">Documentação POP</Button>
            </Link>
          )}
          <div className="flex items-center space-x-2">
            <ThemeToggle />
            <Button
              variant="outline"
              onClick={() =>
                signOut({ callbackUrl: `${window.location.origin}/` })
              }
            >
              <LogOut className="mr-2 h-4 w-4" />
              Sair
            </Button>
            <UserNav />
          </div>
        </div>
      </div>
    </header>
  );
}
